import { stringify } from 'query-string';
import { HttpClient } from 'api/http-client';
import { Field } from 'api/tasks';

export enum NoteSourceType {
  Company = 'COMPANY',
}

export interface NoteSource {
  sourceId: number;
  sourceType: NoteSourceType;
}
export interface Note {
  noteId: number;
  noteText: string;
  isPinned: boolean;
  noteTitle?: string;
  field: Field;
  createdBy: number;
  createdAt: number;
  updatedBy?: number;
  updatedAt?: number;
  tagIds?: number[];
  objectId?: number;
  objectType?: string;
}
export interface CreateNotePayload {
  note: Pick<Note, 'noteTitle' | 'noteText'> & { subObjectIds?: number[] };
  associatedEntity: NoteSource;
  field: {
    fieldId: number;
  };
}
export interface UpdateNotePayload {
  note: Pick<Note, 'noteId' | 'noteTitle' | 'noteText' | 'isPinned'> & {
    subObjectIds?: number[];
  };
}

class NoteHttpClient extends HttpClient {
  public getAllNotesBySource = async (source: NoteSource): Promise<Note[]> =>
    this.get<Note[]>(`/notes?${stringify(source)}`);

  public createNote = async (payload: CreateNotePayload): Promise<Note> =>
    this.post<Note, CreateNotePayload>('/notes', payload);

  public updateNote = async (payload: UpdateNotePayload): Promise<Note> =>
    this.put<Note, UpdateNotePayload>(`/notes/${payload.note.noteId}`, payload);

  public deleteNote = async (noteId: number): Promise<void> =>
    this.delete(`/notes/${noteId}`);
}
export const NoteAPI = new NoteHttpClient();
